import BaseAction from '@/actions/base_action.js'

export default class extends BaseAction {
  execute(spec, component) {
    const t = TrelloPowerUp.iframe()
    const promise = $tpu.r.cards.setData(spec.cardId, spec.formData, t)
    this.executeCardUpdate(promise, spec, component, true)
  }
}
